import { useState } from 'react'

import cn from 'clsx'

import { ArrowLeft } from '@App/static/icons/DashboardIcons'
import { CheckIcon } from '@App/static/icons/FooterIcons'
import OutsideClickComponent from '@App/ui/crypto_exchange/desktop/components/common/OutsideClickHandler'

import s from './Select.module.scss'

export const Select = <T,>({
  onChange,
  value,
  placeholder,
  options,
  containerClassName,
  inputClassName,
  optionsClassName,
  optionClassName,
  optionNameClassName,
  label,
}: {
  value?: T | null
  options: { name: string; subname?: string; value: T; disabled?: boolean }[]
  onChange?: (value: T) => void
  placeholder?: string
  label?: string
  containerClassName?: string
  inputClassName?: string
  optionsClassName?: string
  optionClassName?: string
  optionNameClassName?: string
}) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <OutsideClickComponent
      className={cn(s.container, containerClassName)}
      handler={() => setIsOpen(false)}
      onClick={() => setIsOpen(!isOpen)}
    >
      {label && <span className={s.label}>{label}</span>}
      <div className={cn(s.select, isOpen && s.active, label && s.withLabel, inputClassName)}>
        {value ? options.find((o) => o.value === value)?.name : placeholder}
      </div>
      <ArrowLeft className={cn(s.arrowIcon, isOpen ? s.open : s.close)} />
      {isOpen && (
        <ul className={cn(s.options, optionsClassName)}>
          {options.map((option) => (
            <li
              key={option.name}
              className={cn(s.option, option.subname && s.withSubName, option.disabled && s.disabled, optionClassName)}
              onClick={() => {
                if (!option.disabled) {
                  onChange?.(option.value)
                }
              }}
            >
              <span className={cn(s.name, optionNameClassName)}>{option.name}</span>
              {option.subname && <span className={s.subname}>{option.subname}</span>}
              {value === option.value && <CheckIcon className={s.checkIcon} />}
            </li>
          ))}
        </ul>
      )}
    </OutsideClickComponent>
  )
}
